export default __webpack_public_path__ + "images/favicon-16x16.png";